import { render, staticRenderFns } from "./le-price-service.vue?vue&type=template&id=3995d2d6&scoped=true&"
import script from "./le-price-service.vue?vue&type=script&lang=js&"
export * from "./le-price-service.vue?vue&type=script&lang=js&"
import style0 from "./le-price-service.vue?vue&type=style&index=0&id=3995d2d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3995d2d6",
  null
  
)

export default component.exports